"use strict";
//####################################################

/*  App Bootstrap:                               */

/*  Gates and Scopes are setup in SettingsSetup  */
//####################################################
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _backboneHubHttp = _interopRequireDefault(require("backbone-hub-http"));

var _getPathname = _interopRequireDefault(require("crm_internal/utils/getPathname"));

var _addPortalIdToUrl = _interopRequireDefault(require("crm_internal/utils/addPortalIdToUrl"));

var _I18n = _interopRequireDefault(require("I18n"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _q = _interopRequireDefault(require("q"));

var QHandlers = _interopRequireWildcard(require("q/js/handlers"));

var UsageLoggerRequiredData = _interopRequireWildcard(require("crm_internal/usage/UsageLoggerRequiredData"));

var _loggers = require("customer-data-tracking/loggers");

var _RouterSetup = _interopRequireDefault(require("./RouterSetup"));

var _AlertSetup = _interopRequireDefault(require("./AlertSetup"));

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var _TrackingSetup = _interopRequireDefault(require("./TrackingSetup"));

var _LocaleSetup = _interopRequireDefault(require("./LocaleSetup"));

var _SettingsSetup = _interopRequireDefault(require("./SettingsSetup"));

var _SetupData = _interopRequireDefault(require("crm_data/setup/SetupData"));

var _navigationOverride = _interopRequireDefault(require("crm_internal/utils/navigationOverride"));

var _GeneralStoreSetup = _interopRequireDefault(require("./GeneralStoreSetup"));

var _CurrentOwnerIdStore = _interopRequireDefault(require("crm_data/owners/CurrentOwnerIdStore"));

var _CurrentOwnerContainer = _interopRequireDefault(require("crm_internal/containers/CurrentOwnerContainer"));

var _connectPromiseSingle = require("crm_data/flux/connectPromiseSingle");

var _user = _interopRequireDefault(require("hub-http-shims/UserDataJS/user"));

var _portal = _interopRequireDefault(require("hub-http-shims/PortalDataJS/portal"));

_backboneHubHttp.default.setClient(_apiClient.default);

QHandlers.logQPromiseIssuesAndSendAlerts();

var portalId = _hubspot.default.get({
  preserveGlobalId: false
}); // triggers if we have the PortalId but it's not present in the URL, in which case we try and add it in where it's needed


if (portalId != null && !(0, _getPathname.default)()) {
  window.location = (0, _addPortalIdToUrl.default)(window.location.pathname, portalId);
}

var init = function init() {
  (0, _GeneralStoreSetup.default)();
  var fetchCurrentOwnerId = (0, _connectPromiseSingle.connectPromiseSingle)(_CurrentOwnerIdStore.default); // Return a promise that is resolved when every promise in Auth initializers
  // and I18n has resolved. AKA, when everything is ready.

  return _q.default.Promise.all([(0, _userInfo.default)(), fetchCurrentOwnerId(), _user.default.then(), _portal.default.then()]);
};

var setup = function setup(router, onFinished) {
  var i18nInit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return _I18n.default.Info;
  };
  var setI18nLocale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

  if (window.performance && window.performance.mark) {
    window.performance.mark('mark_setup_loaded');
  }

  return init().then(function (infoModules) {
    var _infoModules = (0, _slicedToArray2.default)(infoModules, 2),
        auth = _infoModules[0],
        ownerId = _infoModules[1];

    _CurrentOwnerContainer.default.set(ownerId);

    _CurrentOwnerContainer.default.initializeIsJitaUser(ownerId, auth);

    if (window.performance && window.performance.mark) {
      window.performance.mark('mark_setup_fetched');
    }

    setI18nLocale(auth);
    (0, _SetupData.default)(auth);
    (0, _SettingsSetup.default)(auth);
    (0, _TrackingSetup.default)();
    (0, _LocaleSetup.default)();
    (0, _navigationOverride.default)();

    _loggers.CrmLogger.init(UsageLoggerRequiredData.get());

    _AlertSetup.default.setup();

    return i18nInit().then(function () {
      // router setup has to happen after I18n is initialized
      (0, _RouterSetup.default)(router);
      return typeof onFinished === 'function' ? onFinished() : undefined;
    });
  });
};

var _default = {
  setup: setup
};
exports.default = _default;
module.exports = exports.default;